<template>
  <form-wrapper
    :target="getId"
    :inline="inline"
    :icon="icon"
    :icon-classes="iconClasses"
    :underlined="underlined"
    :label-classes="labelClasses"
    :label="label"
    :error="error"
    :focused="focused"
    :required="required"
    :hasValue="!isValueEmpty"
  >
    <vue-tel-input
      :class="[fieldClasses, getFieldClasses]"
      v-model="model"
      @focus="onFocus"
      @blur="onBlur"
      @input="onDebounce"
      mode="international"
      :input-options="{
        placeholder: placeholder
      }"
    ></vue-tel-input>
    <template #label><slot name="label"></slot></template>
    <template #icon><slot name="icon"></slot></template>
    <template #action><slot name="action"></slot></template>
  </form-wrapper>
</template>

<script>
import { debounce } from "debounce";
import { VueTelInput } from 'vue-tel-input';
import FormWrapper from "./FormWrapper";
import _ from "lodash";

export default {
  components: {
    FormWrapper,
    VueTelInput
  },
  props: {
    value: String,
    label: String,
    name: String,
    placeholder: String,
    icon: String,
    fieldClasses: [String, Array],
    labelClasses: [String, Array],
    iconClasses: [String, Array],
    error: [String, Array, Object],
    type: {
      type: String,
      default: 'text'
    },
    underlined: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    getFieldClasses() {
      return {
        'border-blue-100 is-underlined': this.underlined,
        'has-error focus:border-orange-500 hover:border-orange-500': this.error,
        'has-icon': this.icon && !this.focused,
      }
    },
    getId() {
      return this.name ? `${this.name}-${this._uid}` : this._uid
    },
    isValueEmpty() {
      return this.type === 'date' ? false : _.isEmpty(this.model)
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onDebounce: debounce(function() {
      this.$emit('debounce', this.model)
    }, 1000),
    onFocus () {
      this.focused = true
    },
    onBlur () {
      this.focused = false
    }
  }
}
</script>

<style scoped>
/* purgecss start ignore */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
input::-webkit-inner-spin-button,
input::-webkit-calendar-picker-indicator,
input::-webkit-clear-button {
  display: none;
  -webkit-appearance: none;
}
/* purgecss end ignore */
</style>

